<!--  -->
<template>
  <div class='company__msg--wrap'>
    <div class="company__msg__title">关于浪微澜</div>
    <div class="company__msg__content"
         style="margin-top:40px;">
      浪微澜科技（广州）有限公司于2022年8月26日正式运营上线，依托电子政务展开系统研发，目前上线运营的系统为商事登记个人数字证书互联网办证系统，税务申报企业数字证书互联网办证系统，着力于解决企业和群众到政府
      <span style="font-weight:700;">办事环节多、效率低、办事难等问题</span>，努力实现企业和群众<span style="font-weight:700;">少跑腿、好办事、不添堵</span>。为不断推动互联互通的进程，助力企业全程电子化工作，开通“网上办事”服务。
    </div>
    <div class="company__msg__content"
         style="margin-top:20px">我司服务于广州市 “市民签”个人数字身份认证以来，已向广州地区签发量已超过100万张个人身份认证数字证书。数字身份认证服务打破了企业登记注册服务异地申请困局，缩短了企业开办时间，为统一商事登记服务标准和推进商事登记无纸化发挥积极作用。实现了个人开办企业“<span style="font-weight:700;">只跑一次</span>”，有效促进营商环境的改善。</div>
    <div style="margin-top:100px;color:#333;font-size:32px;font-weight:bold;">联系我们</div>
    <div class="contract__out--wrap">
      <div class="map">
        <img :src="imgUrl"
             alt="">
      </div>
      <div class="contract__in--wrap">
        <div class="iconfont icon-zuoyinhao"
             style="font-size:32px;color: #EEEEEE;"></div>
        <div class="contract__title">致力于为客户提供“高效、安全、可靠”的电子认证服务</div>
        <div class="iconfont icon-youyinhao"
             style="font-size:32px;color: #EEEEEE;text-align:right;"></div>
        <div class="item--wrap"
             style="margin-top:24px;">
          <div class="iconfont icon-dizhi"
               style="font-size:24px;"></div>
          <div class="right--wrap">
            <div style="font-size:20px;font-weight:bold;color:#333;">广州</div>
            <div style="font-size:14px;color:#333;margin-top:8px;">广州市白云区同和街同沙路283号之二2009号B1751房</div>
          </div>
        </div>

        <div class="item--wrap"
             style="margin-top:24px;">
          <div class="iconfont icon-dianhua"
               style="font-size:24px;color:#333;"></div>
          <div class="right--wrap">
            <div style="font-size:20px;font-weight:bold;color:#333;">{{phone}}</div>

          </div>
        </div>

        <div class="item--wrap"
             style="margin-top:24px;">
          <div class="iconfont icon-youxiang"
               style="font-size:24px;color:#333;"></div>
          <div class="right--wrap">
            <div style="font-size:20px;font-weight:bold;color:#333;">{{email}}</div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '../../../../utils/request'
export default {
  name: 'CompanyMsgView',
  components: {},
  data () {
    return {
      phone: '020-26232815',
      email: 'gzlangweilan@163.com',
      mapImg: '',
      imgUrl: 'https://restapi.amap.com/v3/staticmap?location=113.331628,23.198116&zoom=10&size=550*280&markers=mid,0xFF0000,A:113.331628,23.198116&key=3716f6f8387476b6e5dc0c1e093be362'

    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {
    getMap () {
      service({
        url: 'https://restapi.amap.com/v3/staticmap?location=116.481485,39.990464&zoom=10&size=750*300&markers=mid,,A:116.481485,39.990464&key=3716f6f8387476b6e5dc0c1e093be362',
        method: 'get'

      }).then(res => {
        console.log(res)
        this.mapImg = res.data
      })
    }
  },
  created () {

  },
  mounted () {
    // this.getMap()
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.company__msg--wrap {
  display: flex;
  justify-content: center;
  padding: 0 360px;
  flex-direction: column;
  align-items: center;
  .company__msg__title {
    margin-top: 100px;
    border-radius: 8px;

    font-size: 32px;
    font-weight: 500;
    letter-spacing: 0px;
    color: rgba(51, 51, 51, 1);
  }
  .contract__out--wrap {
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    // align-items: center;
    .map {
      width: 720px;
      height: 350px;
      display: flex;
      // justify-content: center;
      // align-items: center;
    }
    .contract__in--wrap {
      margin-left: 40px;
      .contract__title {
        margin-top: 16px;
        font-size: 24px;
        font-weight: 500;
        letter-spacing: 0px;

        color: rgba(51, 51, 51, 1);
      }
      .item--wrap {
        display: flex;
        .right--wrap {
          margin-left: 16px;
        }
      }
    }
  }
}
</style>
